<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-breadcrumbs :items="breadcrumbs">
                        <template v-slot:divider>
                            <v-icon>chevron_right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </v-col>
            </v-row>
            <v-row >
                <v-col>
                <v-tabs v-model="activeTab"
                        background-color="primary"
                        dark>
                    <v-tab :to="`/clients/${clientId}`">
                        Overview
                    </v-tab>
                    <v-tab :to="`/clients/${clientId}/edit`">
                        Edit
                    </v-tab>
                    <v-tab :to="`/clients/${clientId}/specialists`">
                        Specialists
                    </v-tab>
                    <v-tab :to="`/clients/${clientId}/services`">
                        Services
                    </v-tab>
                </v-tabs>
                </v-col>
            </v-row>
            <v-row >
                <v-col>
                    <v-card>
                        <v-card-text class="text--primary">
                            <router-view :client="client"></router-view>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'

    export default {
        name: "Client",
        props: {
            clientId: String
        },
        data() {
            return {
                activeTab: null
            }
        },
        computed: {
            ...mapState({}),
            ...mapGetters({
                clientsById: 'clients/clientsById'
            }),
            breadcrumbs() {
                let currentRouteName = this.$router.currentRoute.name
                const client = this.clientsById[this.clientId]
                return [
                    {
                        text: 'Clients',
                        disabled: false,
                        href: '#/clients'
                    },
                    {
                        text: client.title,
                        disabled: true,
                    }
                ]
            },
            client () {
                return this.clientsById[this.clientId] || null
            }
        }
    }
</script>

<style scoped>

</style>